<template>
    <div>
        <div class="text-left">
            <h3 class="mb-3">{{$t('cal_milti_Target')}}</h3>
            <p>{{$t('cal_milti_Target_txt')}}</p>
        </div>
        <div class="verticallyTab mt-5">
            <p v-if="message != ''" style="color:red">{{message}}</p>
            <div class="bottomTab w-100">
                <div class="stepForm-contact mt-5">
                    <div class="row">
                        <div class="col-12 col-md-4">
                            <div class="form-group field-wrapper">
                                <select class="selectpicker float-field form-control" @change="currencyList()" v-model="segm" v-validate="'required'" name="segm" :class="{ 'is-invalid': submitted && errors.has('segm'), 'active' : segm != '' }" onclick="this.setAttribute('value', this.value);" value="">
                                   <!--  <option value=""></option> -->
                                    <option value="Forex">{{$t('cal_marg_forex')}}</option>
                                    <option value="Commodities">{{$t('cal_marg_commodities')}}</option>
                                    <option value="INDICIES">{{$t('cal_marg_indices')}}</option>
                                    <!--<option>Crypto</option>-->
                                </select>
                                <label class="float-label">Asset Class</label>
                                <p class="error" v-if="submitted" v-for="error in errors.collect('segm')">{{$t('cal_milti_Field_req')}}</p>
                            </div>
                        </div>
                        <div class="col-12 col-md-4">
                            <div class="form-group field-wrapper">
                                <select class="selectpicker float-field form-control" v-model="basecurreny" v-validate="'required'" name="basecurreny" :class="{ 'is-invalid': submitted && errors.has('basecurreny'), 'active' : basecurreny != '' }" onclick="this.setAttribute('value', this.value);" value="">
                                    <!-- <option value=""></option> -->
                                    <option value="USD">{{$t('cal_comm_USD')}}</option>
                                    <option value="GBP">{{$t('cal_comm_GBP')}}</option>
                                    <option value="AUD">{{$t('cal_comm_AUD')}}</option>
                                    <option value="EUR">{{$t('cal_comm_EUR')}}</option>
                                </select>
                                <label class="float-label">{{$t('cal_milti_accBaseCurr')}}</label>
                                <p class="error" v-if="submitted" v-for="error in errors.collect('basecurreny')">{{$t('cal_milti_Field_req')}}</p>
                            </div>
                        </div>
                        <div class="col-12 col-md-4">
                            <div class="form-group field-wrapper">
                                <select class="selectpicker float-field form-control" v-model="selectedSymbol" v-validate="'required'" name="selectedSymbol" :class="{ 'is-invalid': submitted && errors.has('selectedSymbol'), 'active' : selectedSymbol != '' }" onclick="this.setAttribute('value', this.value);" value="">
                                    <!-- <option value=""></option> -->
                                    <option v-for="spreads in isins" :value="spreads">{{spreads}}</option>
                                </select>
                                <label class="float-label">{{$t('cal_milti_Symbol')}}</label>
                                <p class="error" v-if="submitted" v-for="error in errors.collect('selectedSymbol')">{{$t('cal_milti_Field_req')}}</p>
                            </div>
                        </div>
                        <div class="col-12 col-md-12">
                            <div class="form-group field-wrapper text-left">
                                <label class="float-label-custom">{{$t('cal_milti_Position_Type')}}</label>
                                <div class="d-flex align-items-center mb-3">
                                    <label class="customRadio-button  m-0 mr-2">{{$t('cal_milti_Buy')}}
                                        <input type="radio" class="form-control" value="B" v-model="orderType"  v-validate="'required'" name="orderType" :class="{ 'is-invalid': submitted && errors.has('orderType') }">
                                        <span class="checkmark"></span>
                                    </label>
                                    <label class="customRadio-button m-0">{{$t('cal_milti_Sell')}}
                                        <input type="radio" class="form-control" value="S" v-model="orderType" v-validate="'required'" name="orderType" :class="{ 'is-invalid': submitted && errors.has('orderType') }">
                                        <span class="checkmark"></span>
                                    </label>
                                    <p class="error" v-if="submitted" v-for="error in errors.collect('orderType')">{{$t('cal_milti_Field_req')}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-4">
                            <div class="form-group field-wrapper">
                                <input placeholder=" " type="text"  class="float-field form-control" v-model="openPrice"  v-validate="'required'" name="openPrice" :class="{ 'is-invalid': submitted && errors.has('openPrice') }">
                                <label class="float-label">{{$t('cal_milti_Open_Price')}}</label>
                                <p class="error" v-if="submitted" v-for="error in errors.collect('openPrice')">{{$t('cal_milti_Field_req')}}</p>
                            </div>
                        </div>
                        <div class="col-12 col-md-4">
                            <div class="form-group field-wrapper">
                                <input placeholder=" " type="text" class="float-field form-control" v-model="closePrice"  v-validate="'required'" name="closePrice" :class="{ 'is-invalid': submitted && errors.has('closePrice') }">
                                <label class="float-label">{{$t('cal_milti_Stop_loss_Price')}}</label>
                                <p class="error" v-if="submitted" v-for="error in errors.collect('closePrice')">{{$t('cal_milti_Field_req')}}</p>
                            </div>
                        </div>
                        <div class="col-12 col-md-4">
                            <div class="form-group field-wrapper">
                                <input type="text" v-model="tradesize" class="float-field form-control"  v-validate="'required'" name="tradesize" :class="{ 'is-invalid': submitted && errors.has('tradesize') }">
                                <label class="float-label" style="text-transform: none !important;">{{$t('cal_milti_trade_size_lot')}}</label>
                                <p class="error" v-if="submitted" v-for="error in errors.collect('tradesize')">{{$t('cal_milti_Field_req')}}</p>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group field-wrapper">
                                <input placeholder=" " type="text" class="float-field form-control" v-model="TP1" v-validate="'required'" name="TP1" :class="{ 'is-invalid': submitted && errors.has('TP1') }">
                                <label class="float-label">{{$t('cal_milti_Target_Price')}} 1</label>
                                <p class="error" v-if="submitted" v-for="error in errors.collect('TP1')">{{$t('cal_milti_Field_req')}}</p>
                            </div>
                            <div class="form-group field-wrapper">
                                <input placeholder=" " type="text" class="float-field form-control" v-model="TP2"  v-validate="'required'" name="TP2" :class="{ 'is-invalid': submitted && errors.has('TP2') }">
                                <label class="float-label">{{$t('cal_milti_Target_Price')}} 2</label>
                                <p class="error" v-if="submitted" v-for="error in errors.collect('TP2')">{{$t('cal_milti_Field_req')}}</p>
                            </div>
                            <div class="form-group field-wrapper">
                                <input placeholder=" " type="text"  class="float-field form-control" v-model="TP3"  v-validate="'required'" name="TP3" :class="{ 'is-invalid': submitted && errors.has('TP3') }">
                                <label class="float-label">{{$t('cal_milti_Target_Price')}} 3</label>
                                <p class="error" v-if="submitted" v-for="error in errors.collect('TP3')">{{$t('cal_milti_Field_req')}}</p>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group field-wrapper">
                                <input placeholder=" " type="text" class="float-field form-control" v-model="trgtLots1" v-validate="'required'" name="trgtLots1" :class="{ 'is-invalid': submitted && errors.has('trgtLots1') }">
                                <label class="float-label">{{$t('cal_milti_lots_Clos_Target')}} 1</label>
                                <p class="error" v-if="submitted" v-for="error in errors.collect('trgtLots1')">{{$t('cal_milti_Field_req')}}</p>
                            </div>
                            <div class="form-group field-wrapper">
                                <input placeholder=" " type="text" class="float-field form-control" v-model="trgtLots2" v-validate="'required'" name="trgtLots2" :class="{ 'is-invalid': submitted && errors.has('trgtLots2') }">
                                <label class="float-label">{{$t('cal_milti_lots_Clos_Target')}} 2</label>
                                <p class="error" v-if="submitted" v-for="error in errors.collect('trgtLots2')">{{$t('cal_milti_Field_req')}}</p>
                            </div>
                            <div class="form-group field-wrapper">
                                <input placeholder=" " type="text" class="float-field form-control" v-model="trgtLots3"  v-validate="'required'" name="trgtLots3" :class="{ 'is-invalid': submitted && errors.has('trgtLots3') }">
                                <label class="float-label">{{$t('cal_milti_lots_Clos_Target')}} 3</label>
                                <p class="error" v-if="submitted" v-for="error in errors.collect('trgtLots3')">{{$t('cal_milti_Field_req')}}</p>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">

                        </div>
                        <div class="col-12 col-md-6 text-left">
                            <p class="mb-5">{{$t('cal_milti_Net_Lot_size')}} {{(parseFloat(trgtLots1)+parseFloat(trgtLots2)+parseFloat(trgtLots3)) - tradesize}}</p>
                        </div>
                        <div class="col-12 col-md-12">
                            <div class="form-group field-wrapper">
                                <a href="#" class="common_btn" v-on:click.prevent="calculateMulti()">{{$t('cal_milti_Now')}}</a>
                                <!--  <p class="mt-3">Current Market Price : 123.45</p> -->
                                <div class="table-responsive">
                                    <table class="table commodities-table fundingMethodstable  table-bordered table-striped my-5">
                                        <thead>
                                            <tr>
                                                <th>{{$t('cal_milti_Target_Profit')}} 1</th>
                                                <th>{{$t('cal_milti_Target_Profit')}} 2</th>
                                                <th>{{$t('cal_milti_Target_Profit')}} 3</th>
                                                <th>{{$t('cal_milti_Total_Profit')}} </th>
                                                <th>{{$t('cal_milti_Return_Risk')}}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>{{target1.toFixed(2)}}</td>
                                                <td>{{target2.toFixed(2)}}</td>
                                                <td>{{target3.toFixed(2)}}</td>
                                                <td>{{totalSL.toFixed(2)}}</td>
                                                <td>{{returntorisk.toFixed(2)}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
    export default {
        name: 'Margin',
        mixins: [fxViewMixins],
        data() {
            return {
                "isins":'',
                "segm": 'Forex',
                "tradesize": 0,
                "selectedSymbol":"",
                "selectedSeg":"",
                "commission": 0,
                "basecurreny":'USD',
                "orderType": "B",
                "trgtLots1":0,
                "trgtLots2":0,
                "trgtLots3":0,
                "openPrice":0,
                "closePrice":0,
                "returntorisk":0,
                "target1":0,
                "target2":0,
                "target3":0,
                "totalSL":0,
                "TP1":0,
                "TP2":0,
                "TP3":0,
				submitted : false,
				message : '',
                allIsins:''
            }
        },
        created(){
            this.currencyList()
        },
        methods:{
            currencyList(){
                this.allIsins = this.$store.getters['/GET_ISINS_LIST'];
                this.isins = Object.keys(this.allIsins).filter(key => this.allIsins[key].type === this.segm);
                return this.isins;
            },
            calculateMulti(){
				const _that = this
                this.submitted = true;
				this.message = ''

                this.$validator.validate().then(valid => {
                    if (valid) {
						let curPrice = 0
                        let targetPrice1 = 0
                        let targetPrice2 = 0
                        let targetPrice3 = 0
                        let BSPrice = 0
                         let firstCurrency=''
                        let priceFeed= this.$store.getters['/GET_PRICEFEED_DATA'];
                        let selectedCurrecy= this.allIsins[_that.selectedSymbol]
                        if(_that.orderType == 'B'){
                            BSPrice = _that.closePrice - _that.openPrice
                            targetPrice1 = _that.TP1 - _that.openPrice
                            targetPrice2 = _that.TP2 - _that.openPrice
                            targetPrice3 = _that.TP3 - _that.openPrice
                        }
                        if(_that.orderType == 'S'){
                            BSPrice = _that.openPrice - _that.closePrice
                            targetPrice1 = _that.openPrice -  _that.TP1
                            targetPrice2 = _that.openPrice -  _that.TP2
                            targetPrice3 = _that.openPrice -  _that.TP3
                        }
                        if(_that.segm=='Shares'){
                            firstCurrency="USD"
                        }else{
                            if(_that.selectedSymbol.includes('.') || _that.selectedSymbol.includes('(')){
                            if(_that.selectedSymbol.includes('.')){
                                let lastSymbol=_that.selectedSymbol.trim('.')
                                firstCurrency = lastSymbol.slice('3','6')
                            }else if(_that.selectedSymbol.includes('(')){
                                let lastSymbol=_that.selectedSymbol.split('(')[0]
                                firstCurrency = lastSymbol.slice('3','6')
                            }
                            }else if(_that.selectedSymbol.includes('-')){
                            let lastSymbol=_that.selectedSymbol.replace('-', '')
                            firstCurrency = lastSymbol.slice('3','6')
                            }else{                            
                            firstCurrency = _that.selectedSymbol.slice('3','6')
                            }
                        }
                        if(firstCurrency == _that.basecurreny){
                            let secondaryCurrencyPrice = 1
                            curPrice= secondaryCurrencyPrice
                        }else{
                            let secondaryCurrencyPrice = priceFeed[firstCurrency+_that.basecurreny]
                        if(secondaryCurrencyPrice){
                            curPrice = secondaryCurrencyPrice.A
                        }else if(priceFeed[_that.basecurreny+firstCurrency]){
                            secondaryCurrencyPrice = priceFeed[_that.basecurreny+firstCurrency]
                            curPrice = 1/secondaryCurrencyPrice.A
                        }else{
                            let allIsinList = []
                            let filteredIsins=[]
                            let secondPrice=''
                            allIsinList= Object.keys(this.allIsins)
                            filteredIsins = allIsinList.filter(val=>val.includes(firstCurrency)&&val.includes("USD"))
                            let filteredIsinsSecond=[]
                            filteredIsinsSecond = allIsinList.filter(val=>val.includes(_that.basecurreny))
                            let filteredIsinsSecondPrice= priceFeed[filteredIsinsSecond[0]]
                            secondPrice= 1/filteredIsinsSecondPrice.A
                            filteredIsins.forEach(val=>{
                            if(val.slice(0,3)=='USD'){
                                let price= priceFeed['USD'+firstCurrency]
                                curPrice = price.A*secondPrice
                            }else if(val.slice(3,6)){
                                let price= priceFeed[firstCurrency+'USD']
                                curPrice = price.A*secondPrice
                            }
                            })
                        }
                        this.target1 = targetPrice1 * selectedCurrecy.Contract_Size * curPrice * _that.trgtLots1
                        this.target2 = targetPrice2 * selectedCurrecy.Contract_Size * curPrice * _that.trgtLots2
                        this.target3 = targetPrice3 * selectedCurrecy.Contract_Size * curPrice * _that.trgtLots3
                        this.totalSL = this.target1+this.target2+this.target3
                        this.returntorisk = ((this.target1+this.target2+this.target3)/parseFloat(BSPrice * _that.tradesize * selectedCurrecy.Contract_Size * curPrice))
                        }
						
					}
				})
            },
        //    currencyConverstion(selectedSymbol){
        //         //all_currencies_price will get all currecies prices

        //          let secondCurrency = selectedSymbol.substring(0, 3);

        //         if(secondCurrency == this.basecurreny){
        //             return 1
        //         }

        //         else if(this.all_currencies_price[secondCurrency+this.basecurreny]){
        //             return this.all_currencies_price[secondCurrency+this.basecurreny].A
        //         } 
 
        //         else if(this.all_currencies_price[this.basecurreny+secondCurrency]){
        //             return 1/this.all_currencies_price[this.basecurreny+secondCurrency].A
        //         } 
        //         else{

        //             let secontoUSD = 0
        //             let accBasetoUSD = 0
        //             if(this.all_currencies_price[secondCurrency+"USD"]){
        //                 secontoUSD = this.all_currencies_price[secondCurrency+"USD"].A
        //             } 
        //             else if(this.all_currencies_price["USD"+secondCurrency]){
        //                 secontoUSD = 1/this.all_currencies_price["USD"+secondCurrency].A
        //             } 

        //             if(this.basecurreny=="USD"){
        //                 accBasetoUSD = 1
        //             }
        //             else if(this.all_currencies_price[this.basecurreny+"USD"]){
        //                 accBasetoUSD = 1/this.all_currencies_price[this.basecurreny+"USD"].A
        //             } 
        //             else if(this.all_currencies_price["USD"+this.basecurreny]){
        //                 accBasetoUSD = this.all_currencies_price["USD"+this.basecurreny].A
        //             } 

        //             return accBasetoUSD*secontoUSD
        //         }
        //         return 1
        //     },
        //     currencyConverstionSecond(selectedSymbol){
        //         //all_currencies_price will get all currecies prices

        //         let secondCurrency = selectedSymbol.substring(3, 6);

        //         if(secondCurrency == this.basecurreny){
        //             return 1
        //         }

        //         else if(this.all_currencies_price[secondCurrency+this.basecurreny]){
        //             return this.all_currencies_price[secondCurrency+this.basecurreny].A
        //         } 
 
        //         else if(this.all_currencies_price[this.basecurreny+secondCurrency]){
        //             return 1/this.all_currencies_price[this.basecurreny+secondCurrency].A
        //         } 
        //         else{

        //             let secontoUSD = 0
        //             let accBasetoUSD = 0
        //             if(this.all_currencies_price[secondCurrency+"USD"]){
        //                 secontoUSD = this.all_currencies_price[secondCurrency+"USD"].A
        //             } 
        //             else if(this.all_currencies_price["USD"+secondCurrency]){
        //                 secontoUSD = 1/this.all_currencies_price["USD"+secondCurrency].A
        //             } 

        //             if(this.basecurreny=="USD"){
        //                 accBasetoUSD = 1
        //             }
        //             else if(this.all_currencies_price[this.basecurreny+"USD"]){
        //                 accBasetoUSD = 1/this.all_currencies_price[this.basecurreny+"USD"].A
        //             } 
        //             else if(this.all_currencies_price["USD"+this.basecurreny]){
        //                 accBasetoUSD = this.all_currencies_price["USD"+this.basecurreny].A
        //             } 

        //             return accBasetoUSD*secontoUSD
        //         }
        //         return 1
        //     },
        },
        computed:{
            fetchedIsins(){
                let isinData= this.$store.getters['/GET_ISINS_LIST'];                 
				return isinData;
			}
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/fxView/shared/calculators/multi_target.vue